var JsonCartPageId = 0;
var ProductListPageId = 0;
var ProductListId = "";

function MiniCartInit(JsonPId, ProductId) {
    JsonCartPageId = JsonPId;
    ProductListId = ProductId;
    UpdateCart(("Default.aspx?ID=" + JsonCartPageId + "&Redirect=false"));
}

function AddToCart(e, productReference, quantity, unit) {
    
    //for overlay
    var parent = $(e.target).closest('.product-list__item');    
    var errorMessageElem = parent.find('.product__unit-selector-error-message');
    
    if(errorMessageElem.length == 0){
        //for productPage    
        errorMessageElem = $(e.target).parent().parent().prev().find('.product__unit-selector-error-message')        
    }    
    
    quantity = parseInt(quantity);
 
    if (unit !== undefined) {
        $(errorMessageElem).hide();
        if (quantity > 0){
            // IE Fix
            e.preventDefault = function () {
                Object.defineProperty(this, "defaultPrevented", { get: function () { return true; } });
            };

            setTimeout(function () {
                $('body').addClass('minicart-update');
                //$('#minipagecart').addClass("dw-minicart-update");
                $('#minipagecart-button').addClass("btn btn-sm dw-minicart-update");
                setTimeout(function () {
                    $('body').removeClass('minicart-update');
                    //$('#minipagecart').removeClass("dw-minicart-update");
                    $('#minipagecart-button').removeClass("btn btn-sm dw-minicart-update");
                }, 6000);
            }, 2000);

            var btntext = $(e.target).html();
            $(e.target).html("<i class=\"fa fa-circle-o-notch fa-spin\"></i>");
            $(e.target).addClass('faded');
            setTimeout(function () {
                    $(e.target).html(btntext);
                    $(e.target).removeClass('faded');
                },
                1400);

            var Url = "";
            if (productReference.toLowerCase().indexOf("prod") != -1) {
                Url = "Default.aspx?ID=" + JsonCartPageId + "&cartcmd=add";
                Url += "&Quantity=" + quantity;
                Url += "&ProductID=" + productReference;
                Url += "&UnitID=" + unit;
                Url += "&Redirect=false";
            } else {
                Url = "Default.aspx?ID=" + JsonCartPageId + "&cartcmd=add";
                Url += "&Quantity=" + quantity;
                Url += "&ProductNumber=" + productReference;
                Url += "&UnitID=" + unit;
                Url += "&Redirect=false";
            }

            UpdateCart(Url);
        }
    }
    else{
        
        
        
        $(errorMessageElem).show();
    }
};

function UpdateOrderline(e, orderlineReference, quantity) {
    // IE Fix
    e.preventDefault = function () {
        Object.defineProperty(this, "defaultPrevented", { get: function () { return true; } });
    };

    $('#minipagecart').addClass("dw-minicart-update");
    $('#minipagecart-button').addClass("btn btn-sm dw-minicart-update");
    setTimeout(function () {
        $('#minipagecart').removeClass("dw-minicart-update");
        $('#minipagecart-button').removeClass("btn btn-sm dw-minicart-update");
    },
    2800);

    var btntext = $(e.target).html();
    $(e.target).html("<i class=\"fa fa-circle-o-notch fa-spin\"></i>");
    $(e.target).addClass('faded');
    setTimeout(function () {
        $(e.target).html(btntext);
        $(e.target).removeClass('faded');
    },
    1400);

    var Url = "";
    Url = "Default.aspx?ID=" + JsonCartPageId + "&cartcmd=updateorderlines";
    Url += "&QuantityOrderLine" + orderlineReference + "=" + quantity;

    UpdateCart(Url);
};

function EmptyCart() {
    $('#minipagecart').html("<svg class=\"user-navigation__icon user-navigation__icon--basket\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/dist/icons/icons.svg#basket\"></use></svg><span class=\"user-navigation__name\">Kurv</span>");

    UpdateCart("Default.aspx?ID=" + JsonCartPageId + "&cartcmd=emptycart");
}

function UpdateCart(Url) {
    $.ajax({
        cache: false,
        url: Url,
        dataType: "json",
        success: function (data) {
            CartUpdated(data);
        }
    });

    $('.full-cart').hide();
    $('.empty-cart').show();
}

function CartUpdated(Data) {
    var numberProducts = Data.numberofproducts;
    if (Data.paymentfee.length > 3 && Data.paymentfee.indexOf("Snippet") == -1) {
        numberProducts = Number(Data.numberofproducts) - 1;
    }
    $('#minipagecart').html("<svg class=\"user-navigation__icon user-navigation__icon--basket\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/dist/icons/icons.svg#basket\"></use></svg><span class=\"user-navigation__name\">Kurv</span><span class=\"product-quantity\">" + numberProducts + "</span>");
    $('#minipagecart-mobile').html("<svg class=\"mobile-navigation__icon mobile-navigation__icon--basket\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/dist/icons/icons.svg#basket\"></use></svg><span class=\"mobile-navigation__name\">Kurv</span><span class=\"product-quantity\">" + numberProducts + "</span>");
    $('#minipagecart-offcanvas').html("<svg class=\"offcanvas-menu__icon offcanvas-menu__icon--basket\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/dist/icons/icons.svg#basket\"></use></svg><span class=\"offcanvas-menu__name\">Kurv</span><span class=\"product-quantity\">" + numberProducts + "</span>");
    $('#minipagecart-extra').html("<i class=\"fa fa-shopping-cart\"></i> " + numberProducts + " <span class=\"amount\">" + Data.totalprice + "</span>");
    $('#cart-test').html("<svg class=\"user-navigation__icon navbar-search-button--icon  user-navigation__icon--basket\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"/dist/icons/icons.svg#basket\"></use></svg><span class=\"product-quantity\">" + numberProducts + "</span>");
    $('#mincart-total-items').html('<strong>' + numberProducts + '</strong>');

    if (Data.orderlines.length > 0) {
        $('.full-cart').show();
        $('.empty-cart').hide();
    } else {
        $('.full-cart').hide();
        $('.empty-cart').show();
    }

    $('.minicart-content table tbody').empty();

    var totalPriceWithoutVatOrFreight = 0;

    for (var i = 0; i < Data.orderlines.length; i++) {
        Data.orderlines[i].link = Data.orderlines[i].link.replace(("ID=" + JsonCartPageId.toString()),
        ("ID=" + ProductListId.toString()));

        var orderLinePriceWithoutVat = Data.orderlines[i].totalprice.replace(',', '.');
        totalPriceWithoutVatOrFreight += Number(orderLinePriceWithoutVat);


        if (Data.orderlines[i].id == "") {
            Data.orderlines[i].link = "";
        }

        CreateItemFromJson(Data.orderlines[i], '.minicart-content table tbody', '#OrderlineAjaxTemplate');
    }

    var addedtobasketText = "";
    var freefreightprice = 1000;
    var amountRemaining = freefreightprice - totalPriceWithoutVatOrFreight;
    var amountRemainingFloat = parseFloat(amountRemaining).toFixed(2);

    var lastaddedproductname = Data.lastaddedproductname;

    if (amountRemainingFloat > 0 && Data.shippingmethod == "Under1000") {
        addedtobasketText = lastaddedproductname + " er nu tilføjet til kurven - Manglende beløb før fri fragt: " + amountRemainingFloat + " kr.";
    } else {
        addedtobasketText = lastaddedproductname + " er nu tilføjet til kurven";
    }
    

    $('.minicart-paymentfeemethod').html(Data.paymentmethod);
    $('.minicart-paymentfee').html(Data.paymentfee);
    if (Data.paymentfee.indexOf("Snippet") == -1) {
        $('.paymentFee').show();
        //$('.paymentFee').hide();
    }
    else {
        $('.paymentFee').hide();
    }
   
    if (Data.shippingmethod.indexOf("Nej") > -1) {
        $(".minicart__shipping").hide();
    }
    else {
        $(".minicart__shipping").show();
    }
    $('#minicart-shipping').html(Data.shippingmethod);
    $('.minicart-shippingfee').html(Data.shippingfee);
   // $('#minicart-total').html("<strong>" + numberProducts + "</strong>");
    $('.minicart-totalwithoutvat').html("<strong>" + Data.totalprice + "</strong>");
    $('.minicart-totalprice').html("<strong>" + Data.totalpriceclean + "</strong>");
    $('#added-to-basket__text').html(addedtobasketText);
    $('.minicart-vat').html("<strong>" + Data.vat + "</strong>");
	
}

document.addEventListener("DOMContentLoaded", function () {

    var navbarCartIcon = document.getElementById("cart-test");
    var navbarCart = document.getElementsByClassName("navbar-cart")[0];

    navbarCartIcon.addEventListener("mouseover", function (){
        navbarCart.style.display = "block";

    });

//when hovering over the navbarCart and all of the children, the navbarCart will stay open
    navbarCart.addEventListener("mouseover", function (){
        navbarCart.style.display = "block";
    });


//when hovering out of the navbarCart, it will close
    navbarCart.addEventListener("mouseout", function (){
        navbarCart.style.display = "none";
    });

//when hovering out of icon it will close
    navbarCartIcon.addEventListener("mouseout", function (){
        navbarCart.style.display = "none";
    });



});